/* @flow */
import _ from 'lodash';

import type { SearchParams } from './SearchParams';
import type { MediaSearchParams } from './MediaSearchParams';
import { mediaSearchParamsProps } from './MediaSearchParams';
import { searchParamsProps } from './SearchParams';

export type MediaSearchFullParams = SearchParams & MediaSearchParams;

export const mediaSearchFullParamsProps = _.union(mediaSearchParamsProps, searchParamsProps);
